
<a
  class="external-link"
  :href="href"
  target="_blank"
  rel="noopener noreferrer"
>
  <slot />

  <icon class="icon" name="launch" />
</a>
